var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"categorylist p-relative"},[_c('div',{staticClass:"categorylist__wrapper"},[_c('ul',_vm._l((_vm.filteredServiceList),function(category){return _c('CategoryListItem',_vm._b({key:category.key},'CategoryListItem',{category},false))}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }